import angular from 'angular';
import { difference } from 'lodash';

module.exports = angular.module('common.filters.arrayDiff', [])
.filter('arrayDiff', () => difference)
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/arrayDiff.js
 **/